export default function PublicFolderNodeTemplate(node, options) {
    let label = <div className="text-dark">{node.label}</div>;

    return (
        <span className={options.className}>{label}</span> 
    );
};